import React from "react";
import { DatePicker } from "@pd/pd-ui-kit";
import { Control, Controller } from "react-hook-form";

import {
  fromPickerDate,
  toPickerDate,
} from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/normalizeFormDate";
import { IEmployeeProfileForm } from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/model/types";

import FormField from "./FormField";

interface IFormDateFieldProps {
  name: string;
  control: Control<IEmployeeProfileForm>;
  label: string;
  disabled?: boolean;
  className?: string;
  error?: string;
  required?: boolean;
}

const FormDateField = ({
  name,
  control,
  label,
  disabled,
  className,
  error,
  required,
}: IFormDateFieldProps) => (
  <FormField
    label={label}
    className={className}
    error={error}
    required={required}
  >
    <Controller
      name={name as never}
      control={control}
      render={({ onChange, value, onBlur }) => (
        <DatePicker
          value={toPickerDate(value)}
          onBlur={onBlur}
          format="DD.MM.YYYY"
          onChange={(date) => onChange(fromPickerDate(date))}
          disabled={disabled}
          status={error ? "error" : undefined}
        />
      )}
    />
  </FormField>
);

export default FormDateField;
